import * as React from "react"

function SvgEmail(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.199 10.4"
      {...props}
    >
      <path
        d="M12.405 0H1.795A1.8 1.8 0 000 1.795v6.811a1.8 1.8 0 001.795 1.795h10.61a1.8 1.8 0 001.794-1.795V1.795A1.8 1.8 0 0012.405 0zm-.28 1.158L7.1 5.039 2.076 1.158zm.28 8.086H1.795a.638.638 0 01-.637-.639V1.912l5.588 4.316a.578.578 0 00.708 0l5.589-4.316v6.693a.638.638 0 01-.638.639z"
        fill="inherit"
      />
    </svg>
  )
}

export default SvgEmail
